import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";
import {
	TransactionOutlined,
	DeploymentUnitOutlined,
	UsergroupAddOutlined,
	EuroCircleOutlined,
	PercentageOutlined,
	InfoOutlined,
	PlusOutlined,
} from "@ant-design/icons";

// Collaborator
const Collaborators = React.lazy(() =>
	lazyRetry(() => import("features/affiliate/collaborators/CollaboratorList")),
);
const CollaboratorDetail = React.lazy(() =>
	lazyRetry(
		() => import("features/affiliate/collaborators/CollaboratorDetail"),
	),
);

// Conversion
const Conversions = React.lazy(() =>
	lazyRetry(() => import("../features/affiliate/conversion/ConversionList")),
);
const ConversionDetail = React.lazy(() =>
	lazyRetry(() => import("../features/affiliate/conversion/ConversionDetail")),
);

const AffiliatePayment = React.lazy(() =>
	lazyRetry(() => import("../features/affiliate/payment")),
);
const AffiliatePaymentCreate = React.lazy(() =>
	lazyRetry(() => import("../features/affiliate/payment/PaymentCreate")),
);

// Commission policy
const CommissionPolices = React.lazy(() =>
	lazyRetry(
		() => import("features/affiliate/commission-policy/CommissionPolicyList"),
	),
);
const CommissionPolicyDetail = React.lazy(() =>
	lazyRetry(
		() => import("features/affiliate/commission-policy/CommissionPolicyDetail"),
	),
);

// Affiliate routes
const affiliateRoutes = [
	{
		label: "Affiliate",
		path: "",
		key: "affiliate",
		icon: <UsergroupAddOutlined />,
		children: [
			// Collaborator
			{
				label: "Collaborators",
				path: APP_PATH.collaborators,
				key: "collaborators",
				icon: <UsergroupAddOutlined />,
				component: <Collaborators />,
				permissions: [PERMISSION.COLLABORATOR.VIEW],
			},
			{
				label: "Collaborator Detail",
				path: `${APP_PATH.collaborators}/:id`,
				key: "",
				icon: <UsergroupAddOutlined />,
				component: <CollaboratorDetail />,
				hidden: true,
				permissions: [
					PERMISSION.COLLABORATOR.VIEW,
					PERMISSION.COLLABORATOR.UPDATE,
				],
			},

			// Conversion
			{
				label: "Conversions",
				path: APP_PATH.conversions,
				key: "conversions",
				icon: <TransactionOutlined />,
				component: <Conversions />,
				permissions: [
					PERMISSION.AFFILIATE.TRANSACTION.VIEW,
					PERMISSION.AFFILIATE.TRANSACTION.UPDATE,
				],
			},
			{
				label: "Details",
				path: `${APP_PATH.conversions}/:id`,
				key: "",
				hidden: true,
				component: <ConversionDetail />,
				permissions: [PERMISSION.AFFILIATE.TRANSACTION.UPDATE],
			},

			// Payment
			{
				label: "Payment",
				path: APP_PATH.affiliatePayment,
				key: "payment",
				icon: <EuroCircleOutlined />,
				children: [],
				component: <AffiliatePayment />,
				permissions: [
					PERMISSION.AFFILIATE.TRANSACTION.UPDATE,
					PERMISSION.AFFILIATE.TRANSACTION.VIEW,
				],
			},
			{
				label: "Payment Detail",
				path: `${APP_PATH.affiliatePayment}/:id`,
				key: "",
				icon: <DeploymentUnitOutlined />,
				hidden: true,
				component: <AffiliatePaymentCreate />,
				permissions: [PERMISSION.AFFILIATE.TRANSACTION.UPDATE],
			},

			// Commission policy
			{
				label: "Commission policy",
				path: APP_PATH.commissionPolicies,
				key: "commission-policies",
				icon: <PercentageOutlined />,
				children: [],
				component: <CommissionPolices />,
				permissions: [
					PERMISSION.AFFILIATE.TRANSACTION.VIEW,
					PERMISSION.AFFILIATE.TRANSACTION.UPDATE,
				],
			},
			{
				label: "Create",
				path: `${APP_PATH.commissionPolicyCreate}`,
				key: "",
				icon: <PlusOutlined />,
				hidden: true,
				component: <CommissionPolicyDetail />,
				permissions: [PERMISSION.AFFILIATE.TRANSACTION.UPDATE],
			},
			{
				label: "Details",
				path: `${APP_PATH.commissionPolicies}/:id`,
				key: "",
				icon: <InfoOutlined />,
				hidden: true,
				component: <CommissionPolicyDetail />,
				permissions: [PERMISSION.AFFILIATE.TRANSACTION.UPDATE],
			},
		],
	},
];

export default affiliateRoutes;
